
import { mapGetters } from 'vuex'

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      vxFlaps: 'common/getProductsFlaps',
    }),
    flap() {
      if (!this.product || this.vxFlaps?.tag_list?.length <= 0) return null
      let displayFlap = null
      let keys = []
      // BY TAGS or FLAPS
      if (this.product.flaps) keys = [...keys, ...this.product.flaps]
      if (this.product.tags) keys = [...keys, ...this.product.tags]
      keys = this.deleteFalseDiscountFlaps(keys)
      // STRIKEOUT PRICE
      if (this.product.strikeout_price > 0)
        keys.push(
          `${Math.round(
            100 - (this.product.price * 100) / this.product.strikeout_price
          )}%off`
        )
      this.vxFlaps.tag_list.forEach((flap) => {
        if (keys.includes(flap.key) && !displayFlap) {
          if (flap.exclusions) {
            if (!flap.exclusions.includes(this.product.handle))
              displayFlap = flap
          } else {
            displayFlap = flap
          }
        }
      })

      return displayFlap
    },
  },
  methods: {
    deleteFalseDiscountFlaps(flaps) {
      return flaps.filter((tag) => {
        return !tag.includes('%off')
      })
    },
  },
}
